import DashboardService from '../services/DashboardService';

const getDefaultState = () => ({
  studentCount: {},
  teacherCount: {},
  schoolCount: {},
  malawiTrainersActivity: {},
  namibiaTrainersActivity: {},
  trainersTable: [],
  trainerTable: [],
  trainerActivityChart: {},
  schoolsMap: [],
  structureTable: [],
  teacherModuleTable: [],
  studentAttendanceTable: [],
});

const dashboards = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    studentCount(state, val) {
      Object.assign(state.studentCount, val);
    },
    teacherCount(state, val) {
      Object.assign(state.teacherCount, val);
    },
    schoolCount(state, val) {
      Object.assign(state.schoolCount, val);
    },
    malawiTrainersActivity(state, val) {
      state.malawiTrainersActivity = val;
    },
    namibiaTrainersActivity(state, val) {
      state.namibiaTrainersActivity = val;
    },
    trainersTable(state, val) {
      state.trainersTable = val;
    },
    trainerTable(state, val) {
      state.trainerTable = val;
    },
    trainerActivityChart(state, val) {
      state.trainerActivityChart = val;
    },
    schoolsMap(state, val) {
      state.schoolsMap = val;
    },
    structureTable(state, val) {
      state.structureTable = val;
    },
    teacherModuleTable(state, val) {
      state.teacherModuleTable = val;
    },
    studentAttendanceTable(state, val) {
      state.studentAttendanceTable = val;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    resetInd(state) {
      state.trainerTable = [];
      Object.assign(state.trainerActivityChart, {});
    },
  },
  actions: {
    async GET_STUDENT_COUNT(context) {
      const request = await DashboardService.fetchActiveStudentCountByCountry();
      const data = request.data.results;
      context.commit('studentCount', data);
    },
    async GET_TEACHER_COUNT(context) {
      const request = await DashboardService.fetchActiveTeacherCountByCountry();
      const data = request.data.results;
      context.commit('teacherCount', data);
    },
    async GET_SCHOOL_COUNT(context) {
      const request = await DashboardService.fetchSchoolCountByCountry();
      const data = request.data.results;
      context.commit('schoolCount', data);
    },
    async GET_MALAWI_TRAINERS_ACTIVITY(context) {
      const request = await DashboardService.fetchMalawiTrainersActivity();
      const data = request.data.results;
      context.commit('malawiTrainersActivity', data);
    },
    async GET_NAMIBIA_TRAINERS_ACTIVITY(context) {
      const request = await DashboardService.fetchNamibiaTrainersActivity();
      const data = request.data.results;
      context.commit('namibiaTrainersActivity', data);
    },
    async GET_TRAINERS_TABLE(context) {
      const request = await DashboardService.fetchTrainersTable();
      const data = request.data.results;
      context.commit('trainersTable', data);
    },
    async GET_TRAINER_TABLE(context, id) {
      const request = await DashboardService.fetchTrainerTable(id);
      const data = request.data.results.rows;
      context.commit('trainerTable', data);
    },
    async GET_TRAINER_ACTIVITY_CHART_DATA(context, id) {
      const request = await DashboardService.fetchTrainerActivityChart(id);
      const data = request.data.results;
      context.commit('trainerActivityChart', data);
    },
    async GET_SCHOOLS_MAP(context) {
      const request = await DashboardService.fetchSchoolsMap();
      const data = request.data.results;
      context.commit('schoolsMap', data);
    },
    async GET_STRUCTURE_TABLE(context) {
      const request = await DashboardService.fetchStructureTable();
      const data = request.data.results;
      context.commit('structureTable', data);
    },
    async GET_TEACHER_MODULE_TABLE(context) {
      const request = await DashboardService.fetchTeacherTrainingModuleTable();
      const data = request.data.results.rows;
      context.commit('teacherModuleTable', data);
    },
    async GET_STUDENT_ATTENDANCE_TABLE(context) {
      const request = await DashboardService.fetchStudentAttendanceTable();
      const data = request.data.results.rows;
      context.commit('studentAttendanceTable', data);
    },
    async RESET_IND(context) {
      await context.commit('resetInd');
    },
    async RESET_STATE(context) {
      await context.commit('resetState');
    },
  },
  getters: {
    getTrainersTableSansNull: state =>
      state.trainersTable.map(c => ({
        tid: c.tid,
        trainer_name: c.trainer_name,
        active: c.active,
        country: c.country,
        sex: c.sex,
        stu_ct: c.stu_ct === null ? 0 : parseInt(c.stu_ct),
        tea_ct: c.tea_ct === null ? 0 : parseInt(c.tea_ct),
        sch_ct: c.sch_ct === null ? 0 : parseInt(c.sch_ct),
        tm_ct: c.tm_ct === null ? 0 : parseInt(c.tm_ct),
        co_ct: c.co_ct === null ? 0 : parseInt(c.co_ct),
        tw_ct: c.tw_ct === null ? 0 : parseInt(c.tw_ct),
      })),
    getTrainerTable: state => state.trainerTable,
    getTrainerActivityChartData: state => state.trainerActivityChart,
  },
};

export default dashboards;
